import {getNow, parseDateTime} from '../../../lib/dates'
import {coerceBoolean, alert} from '../../../lib/utils'
import CartMixin from '../../../components/_mixins/location-checkout'
import PageMixins from '../../../components/_mixins/pages'
import ProviderService from '../../../services/booking'
import {rateType} from '../../../vuexstore/modules/tickets'

const EventBus = window.VueEventBus

export default {
  mixins: [PageMixins, CartMixin],
  props: {
    item: {},
    items: {},
    groupedItems: {},
    cartView: {},
    columnClasses: {},
    // valid: {},
    // errors: {},
    error: {}
  },
  data() {
    return {
      itemInvalid: false,
      itemValidationError: null,
      holdId: null,
      isUpdating: false,
      newQuantity: null,
    }
  },
  computed: {
    cartItemHasTimedOut() {
      const holdEnds = 1 * _.get(this.itemForm, 'holdEndsAt', 0)
      const now = getNow().toSeconds()
      return now >= holdEnds
    },
    itemPayload() {
      return _.get(this.item || {}, 'payload', {})
    },
    itemOptions() {
      return this.itemPayload.options || {}
    },
    itemAttributes() {
      return _.get(this.item || {}, 'attributes', {})
    },
    itemForm() {
      return this.itemAttributes.form
    },
    itemProduct() {
      return this.itemAttributes.product
    },
    itemSlot() {
      return this.itemAttributes.slot || {}
    },
    maxParticipants() {
      return Math.min(this.itemSlot.quantity, this.itemProduct.max_participants)
    },
    itemHold() {
      return this.itemSlot.hold
    },
    itemTitle() {
      return this.item.title
    },
    itemDescription() {
      return this.item.description
    },
    slottedDateFormatted() {
      return this.itemAttributes.formattedDate
    },
    slottedTimeFormatted() {
      return this.itemAttributes.formattedTime
    },
    itemCount() {
      return this.item.payload.options.participants
    },
    itemRate() {
      const {rates, price} = this.itemProduct
      return _.toFinite((_.find(rates, rate => rate.tag === rateType) || {}).price || price)
    },
    itemTax() {
      const {tax} = this.itemProduct
      return _.round(_.toFinite(tax) * this.itemCount, 2)
    },
    itemSubtotal() {
      return _.round(this.itemRate * this.itemCount, 2)
    },
    itemTotal() {
      return _.round(this.itemSubtotal + this.itemTax, 2)
    },
  },
  async created() {
    const item = this.item
    const itemId = item.id
    this.holdId = _.get(item, 'attributes.reservation_hold_id')

    EventBus.$once('timer.timeout', async (id) => {
      if (id === this.currentLocationId) {
        const autoRemoveItem = coerceBoolean(this.$$s('timer.expired.items.autoRemove', false))
        this.setTimeoutRemovedTypes([item.editRoute.name])
        this.setTimeoutRemovedItem(this)
        await this.$nextTick()
        this.showTimeoutAlert()
        await this.$nextTick()
        if (autoRemoveItem) {
          this.removeThisCartItem()
        }
      }
    })

    EventBus.$on('timer.timeout', (location) => {
      const autoRemoveItem = coerceBoolean(this.$$s('timer.expired.items.autoRemove', false))
      if (autoRemoveItem) {
        this.mayResetCountdownTimer()
      } else {
        this.stopTimer()
      }
    })

    EventBus.$on('cart.error.item.expired.validation.' + this.item.id, () => {
      EventBus.$emit('timer.timeout', this.currentLocationId)
    })

    EventBus.$on('cart-cleaned', () => {
      this.unhold()
    })

    EventBus.$on(`cart.validate.before`, () => {
      this.itemInvalid = false
      this.itemValidationError = null
    })

    EventBus.$on(`cart.error.item.validation.${itemId}`, (e) => {
      this.itemInvalid = true
      this.itemValidationError = e.error[0]
    })
  },
  mounted() {
    if (this.cartItemHasTimedOut) {
      EventBus.$emit('timer.timeout', this.currentLocationId)
    } else {
      if (!this.timerIsRunning) {
        EventBus.$emit('timer.timeout', this.currentLocationId)
      }
    }
  },
  methods: {
    removeThisCartItem(skipEvents) {
      this.unhold()
      const item = _.cloneDeep(this.item)
      this.removeCartItem({id: item.id})
      if (!skipEvents) {
        EventBus.$emit('cart-item-deleted', item, this, this.$parent)
        EventBus.$emit('cart-item-deleted-' + item.type, item, this, this. $parent)
      }
    },
    itemDelete($event) {
      const item = _.cloneDeep(this.item)
      this.unsetTimeoutRemovedItem(this)
      this.removeThisCartItem(true)

      this.cartView.cartItemButtonClicked({
        $event,
        actionName: 'delete',
        id: item.id,
        item,
        cartItems: this.currentCartItems,
        button: {}
      })

      EventBus.$emit('cart-item-deleted', item, this, this.$parent)
      EventBus.$emit('cart-item-deleted-' + item.type, item, this, this.$parent)
    },
    itemEdit($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        item,
        actionName: 'edit',
        id: this.item.id,
        cartItems: this.currentCartItems,
        button: {}
      })
      EventBus.$emit('cart-item-edit', item, this, this.$parent)
      EventBus.$emit('cart-item-edit-' + item.type, item, this, this.$parent)

      if (item.editRoute) {
        const route = Object.assign({}, item.editRoute, {query: {token: item.id}})
        this.$router.push(route)
      }

    },
    unhold(hold) {
      const id = (hold && hold.id) || hold || (this.itemHold.id) || this.holdId
      if (id) {
        ProviderService.unhold({id})
      }
    },
    async holdSlot(hold, participants) {
      hold = hold || this.itemHold
      const holdId = hold.id
      this.isUpdating = true
      let newHold
      try {
        const payload = {
          ..._.omit(hold, ['id', 'expire_at', 'participants']),
          ignore_reservation_hold_id: holdId,
        }
        newHold = await ProviderService.hold(payload, participants)
      } catch (e) {
        alert('Unable to set hold on the new quantity.', {classes: 'text-danger'})
      } finally {
        this.isUpdating = false
      }
      if (newHold) {
        return _.merge({}, hold, newHold || {}, {participants})
      }
      return null
    },
    async setCount(newCount) {
      if (newCount >= 1 && newCount <= this.maxParticipants) {
        const newHold = await this.holdSlot(this.itemHold, newCount)
        if (newHold) {
          await this.updateCartItemQuantity(newCount, newHold)
        }
      }
    },
    async updateCartItemQuantity(participants, hold) {
      const item = _.cloneDeep(this.item)
      _.set(item, 'payload.options.participants', participants)

      _.set(item, 'payload.options.reservation_hold_id', hold.id)
      _.set(item, 'attributes.reservation_hold_id', hold.id)

      _.set(item, 'attributes.slot.participants', participants)
      _.set(item, 'attributes.slot.hold', hold)

      _.set(item, 'attributes.form.quantity', participants)
      _.set(item, 'attributes.form.selectedSlots', {
        [this.itemSlot.time]: _.get(item, 'attributes.slot')
      })

      await this.updateCartItem(item)
      EventBus.$emit('cart.validate')
    }
  },
}
